import { styled } from '@linaria/react'

export const Teaser = styled.div`
  color: var(--white);
  background-color: var(--primary);
  border-radius: 5px;
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.25);
  min-height: 360px;
  height: ${props => (props.isSlider ? '100%' : 'auto')};
  position: relative;
  overflow: hidden;
  transition: 0.3s 0.2s ease;
  width: ${props => !props.isSlider && 'calc(100% / 4 - 15px)'};

  @media screen and (max-width: 1200px) {
    width: ${props => !props.isSlider && 'calc(100% / 3 - 15px)'};
  }

  @media screen and (max-width: 992px) {
    min-height: 380px;
    width: ${props => !props.isSlider && 'calc(100% / 2 - 10px)'};
  }

  @media screen and (max-width: 576px) {
    min-height: 360px;
    width: ${props => !props.isSlider && '100%'};
  }

  &:hover,
  &:focus {
    ${Content} {
      padding-bottom: 60px;
      transition: 0.3s ease;
    }

    ${HoverContent} {
      transform: translateY(0);
      transition: 0.5s ease;
    }

    ${Image} {
      &::after {
        opacity: 0.6;
        transition: 0.3s ease;
      }
    }

    ${ReadMore} {
      right: 25px;
      opacity: 1;
      transition: 0.3s 0.2s ease;
    }
  }
`

export const Image = styled.div`
  position: relative;
  padding-bottom: 56.25%;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--primary);
    opacity: 0.2;
    transition: 0.3s 0.2s ease;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
  }
`

export const Content = styled.div`
  background-color: var(--primary);
  padding: 20px 25px 35px;
  transition: 0.3s 0.2s ease;
`

export const HoverContent = styled.div`
  background-color: #00375b;
  padding: 20px 25px 60px;
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  max-height: 100%;
  transform: translateY(100%);
  transition: 0.5s 0.2s ease;

  ${DateBadge} {
    color: var(--secondary);
  }
`

export const Title = styled.h4`
  padding: 0;
  margin-bottom: 0;
`

export const Excerpt = styled.div`
  font-size: var(--font-size-index);
  max-height: 100%;
  overflow: hidden;

  p:last-child {
    margin-bottom: 0;
  }
`

export const DateBadge = styled.div`
  font-size: var(--font-size-index);
  line-height: var(--line-height-index);
  font-weight: var(--font-weight-bold);
  display: block;
  margin-bottom: 0.7rem;
  text-transform: capitalize;

  i {
    font-size: 130%;
    margin-right: 7px;
  }
`

export const Link = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
`

export const ReadMore = styled.span`
  position: absolute;
  bottom: 20px;
  right: 40px;
  z-index: 2;
  font-size: var(--font-size-index);
  line-height: var(--line-height-index);
  font-weight: var(--font-weight-bold);
  color: var(--secondary);
  opacity: 0;
  transition: 0.3s ease;

  i {
    font-size: 130%;
    margin-left: 7px;
    vertical-align: middle;
  }
`
